import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.loadingVoucherTypes, action) => {
  switch (action.type) {
    case types.BEGIN_LOAD_VOUCHER_TYPES:
      return true;
    case types.FINISH_LOAD_VOUCHER_TYPES:
      return false;

    default:
      return state;
  }
};
